import { render, staticRenderFns } from "./MyIndications.vue?vue&type=template&id=b52532e2&"
import script from "./MyIndications.vue?vue&type=script&lang=js&"
export * from "./MyIndications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports